import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'hero.image.alt': {
    id: 'hero.image.alt',
    defaultMessage: 'People learning and performing highly skilled tasks',
    description: 'Alt text for header banner image.',
  },
});

export default messages;
